export const getInitials = (text: string, maxWords = 2): string => {
  return text
    .split(' ')
    .slice(0, maxWords)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};
